import { useContext, useEffect, useState } from "react"
import { AppContext } from "./AppContextProvider"
import { initI18n } from "i18n"

const TranslationInitializer = ({ children }) => {
  const { translationsSasToken } = useContext(AppContext)
  const [i18nReady, setI18nReady] = useState(false)

  useEffect(() => {
    initI18n(translationsSasToken)
      .then(() => setI18nReady(true))
      .catch((err) => {
        console.error("i18n init failed:", err)
        setI18nReady(true)
      })
  }, [translationsSasToken])

  if (!i18nReady) return null

  return children
}

export default TranslationInitializer
